import styled from 'styled-components';

export const Wrapper = styled.div`
    max-width: 500px;
    margin-top: 40px;

    .checkout-title {
        font-size: 15px;
        margin-bottom: 41px;
        font-weight: bold;
    }

    .checkout-grid {
        display: grid;
        grid-gap: 30px;
    }

    .checkout-item {
        display: grid;
        grid-gap: 4px;
        height: 80px;
        position: relative;
        .item-icon {
            color: ${props => props.theme.primary};
            position: absolute;
            bottom: 10px;
            right: 8px;
        }
    }

    .checkout-item-group {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 39px;
        align-items: center;
    }

    .lock-label {
        display: grid;
        align-items: center;
        grid-gap: 8px;
        grid-template-columns: auto 1fr;
        font-size: 12px;
        font-weight: bold;
        padding-top: 21px;
    }

    .checkout-submit-button {
        max-width: 265px;
        margin: 51px auto 0 auto;
    }

    .card-number-frame {
        height: 52px;
    }

    .error-message {
        color: ${props => props.theme.error};
    }

    @media (max-width: ${props => props.theme.mobile}) {
        .checkout-item-group {
            grid-template-columns: 1fr;
        }
    }
`;

export const Input = styled.input`
    font-size: 14px;
    height: 52px;
    border: 1px solid #c6c6c6;
    padding: 8px 11px;
    color: black;

    &:focus {
        outline: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/iframes/checkout/CheckoutStyle.js